import React, { Component } from 'react';
import MImg from '@/components/img';
import { Modal } from 'antd-mobile';
import '@/assets/css/tied-card.scss'

class TiedCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgModal: false,
      imgUrl: '',
    }
  }

  componentDidMount() {
    document.title = 'Consulta';
  }

  handleClick(src) {
    this.setState({
      imgModal: true,
      imgUrl: src
    })
  }

  render() {
    const { imgModal, imgUrl } = this.state
    return <div className='tied-card'>
      <Modal
        className="am-modal_img"
        visible={ imgModal }
        transparent
        maskClosable={ true }
        onClose={ () => this.setState({ imgModal: false }) }
      >
        <MImg src={ imgUrl } />
      </Modal>
      <div className="contend">
        <h1>¿Cómo consultar mi N° de cuenta y N° de cuenta Interbancaria (CCI)?</h1>

        <h2>Banca por Internet</h2>
        <ol>
          <li>
            <p>Ingresar al portal en línea o la aplicación móvil de tu banca de preferencia</p>
            <p>
              <MImg
                src="/h5/img/isolez/tied-card/1.webp"
                onClick={(src)=> this.handleClick(src) }
              />
            </p>
          </li>
          <li>
            <p>Ingresar los datos que te solicitan: N° de tarjeta y clave de 6 dígitos (En caso de no tener clave la generas dando click en “No tengo clave de internet”)</p>
            <p>
              <MImg
                src="/h5/img/isolez/tied-card/2.webp"
                onClick={(src)=> this.handleClick(src) }
              />
            </p>
          </li>
          <li>Escribes el código y le das en ingresar</li>
          <li>
            <p>Una vez dentro seleccionas la cuenta de Ahorros o Cuenta corriente de la que quieres saber el N° de cuenta o N° de cuenta interbancaria.</p>
            <p>
              <MImg
                src="/h5/img/isolez/tied-card/4-1.webp"
                onClick={(src)=> this.handleClick(src) }
              />
            </p>
            <p>
              <MImg
                src="/h5/img/isolez/tied-card/4-2.webp"
                onClick={(src)=> this.handleClick(src) }
              />
            </p>
          </li>
        </ol>

        <h2>Cajeros</h2>
        <ol>
          <li>Ingresar tu tarjeta en la ranura</li>
          <li>Te pedirán el numero de DNI y NIP (4 dígitos)</li>
          <li>Elegir el producto del cual deseas el N° de cuenta o N° de cuenta Interbancario (Ahorro o cuenta corriente)</li>
          <li>Seleccionar el tipo de consulta (verlo en pantalla o imprimir Ticket)</li>
        </ol>

        <h2>LLAMADA AL BANCO</h2>
        <ol>
          <li>Te contesta el conmutador solicitando tu Numero de DNI </li>
          <li>Marcar la opción de comunicarse con un Asesor Op. 9</li>
          <li>Indicar que la consulta será para saber la clave interbancaria</li>
          <li>El asesor te pide la clave la clave de 4 dígitos que ingresas en el cajero (NIP)</li>
          <li>Seguido de esto te dicta la información necesaria</li>
        </ol>
      </div>
    </div>
  }
}

export default TiedCard;
